<template>
  <div style="position: relative;" class="worker-table">
    <gtable-crud
      ref="gtable-crud"
      :search-form="searchQuery"
      :data="data"
      :option="option"
      :pageOptions="pageOptions"
      :page="page"
      :loading="loading"
      :row-style-class="getRowStyle"
      @onPageChange="onPageChange"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @downLoad="downLoad"
      @upload="upload"
      @rowDel="rowDel"
      @refresh-change="refreshChange"
    >
      <template slot="table-row" slot-scope="props">
        <div v-if="props.column.field == 'name'" style="width: 150px;">
          <div class="name-cols">
            <b-avatar
              :src="props.row.photoType ? props.row.photoType.link : ''"
              @click="
                handleImgClick(
                  props.row.photoType ? props.row.photoType.link : ''
                )
              "
            />
            <div style="margin-left: 0.5rem;width: 100px;">
              <p>{{ props.row.employmentCode }}</p>
              <p>{{ props.row.name }}</p>
            </div>
          </div>
        </div>
        <span
          v-else-if="props.column.field == 'teamName' && props.row.teamName"
        >
          {{ props.row.teamName + "'s " + 'TEAM' }}
        </span>
        <span
          v-else-if="
            props.column.field == 'specialistId' && props.row.specialistId
          "
        >
          <my-tooltip :tooltip="props.row.specialistName">
            <b-badge variant="light-primary" style="margin: 0.2rem auto">
              {{ props.row.specialistId }}
            </b-badge>
          </my-tooltip>
        </span>
        <span v-else-if="props.column.field === 'isSupervisor'">
          <template>
            <div
              v-if="props.row.isSupervisor"
              class="status-tag bg-gradient-success"
            />
            <div v-else class="status-tag bg-gradient-secondary" />
          </template>
        </span>
        <!-- <span v-else-if="props.column.field === 'status'">
          <my-tooltip :tooltip="props.row.statusName">
            <template v-if="props.row.status === 2 || props.row.status === 3">
              <div class="status-tag bg-gradient-secondary" />
            </template>
            <template v-else>
              <div class="status-tag bg-gradient-success" />
            </template>
          </my-tooltip>
        </span> -->
        <span v-else-if="props.column.field == 'projectId'">
          <template v-if="props.row.projectId">
            <b-badge variant="light-primary" style="margin: 0.2rem">{{
              props.row.projectName
            }}</b-badge>
          </template>
        </span>
        <span v-else-if="props.column.field == 'signature'">
          <template v-if="props.row.signType">
            <b-img
              v-if="props.row.signType.link"
              height="44"
              :src="props.row.signType.link"
              @click="handleImgClick(props.row.signType.link)"
            />
          </template>
        </span>
        <span v-else-if="props.column.field == 'roleId' && props.row.roleName">
          <template v-if="props.row.roleName">
            <b-badge
              v-for="(item, index) in props.row.roleName.split(',')"
              :key="index"
              variant="light-primary"
              style="margin: 0.2rem 0.2rem"
            >
              {{ item }}
            </b-badge>
          </template>
        </span>
      </template>
      <template slot="menuLeft" slot-scope="{ row }">
        <my-tooltip :tooltip="$t(`_components.btns.view`)">
          <feather-icon
            icon="SearchIcon"
            size="20"
            class="cursor-pointer"
            @click="handleFormOpen('detail', row, 'view')"
          />
        </my-tooltip>
        <my-tooltip :tooltip="$t(`_components.btns.edit`)">
          <feather-icon
            style="margin-left: 1rem"
            icon="Edit2Icon"
            size="20"
            class="cursor-pointer text-warning"
            @click="handleFormOpen('detail', row, 'edit')"
          />
        </my-tooltip>
        <my-tooltip :tooltip="i18n('label.setSupervisor')">
          <!-- fill="#fff" -->
          <icon-park
            v-if="row.isSupervisor !== 1"
            style="margin-left: 1rem;display: inline-block"
            fill="#7367f0"
            :icon="'user-business'"
            variant="primary"
            theme="outline"
            :stroke-width="4"
            size="20"
            class="cursor-pointer"
            @click.native="setSupervisor(row)"
          />
        </my-tooltip>
        <my-tooltip :tooltip="i18n('label.cancelSupervisor')">
          <feather-icon
            v-if="row.isSupervisor === 1"
            style="margin-left: 1rem"
            icon="UserIcon"
            size="20"
            class="cursor-pointer text-warning"
            @click="cancelSupervis(row)"
          />
        </my-tooltip>
      </template>
      <template slot="headMenuLeft">
        <!-- <my-tooltip :tooltip="i18n('btns.batchUpload')">
          <b-button
            variant="primary"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleBlockShow"
          >
            <feather-icon
              size="18"
              icon="UploadIcon"
            />
          </b-button>
        </my-tooltip> -->

        <my-tooltip :tooltip="$t('_components.btns.add')">
          <b-button
            variant="primary"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleFormOpen('add')"
          >
            <feather-icon size="18" icon="PlusIcon" />
          </b-button>
        </my-tooltip>

        <my-tooltip :tooltip="$t('_components.btns.download')">
          <b-button
            :disabled="downloading"
            variant="success"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleDownload"
          >
            <feather-icon icon="DownloadIcon" size="18" />
          </b-button>
        </my-tooltip>

        <my-tooltip :tooltip="$t('_components.btns.upload')">
          <a-upload
            name="excel"
            :show-upload-list="false"
            :custom-request="handleUpLoad"
            :disabled="uploading"
          >
            <div>
              <b-button variant="warning" class="btn ml-0-5 mr-0-5" size="sm">
                <feather-icon icon="UploadIcon" size="18" />
              </b-button>
            </div>
          </a-upload>
        </my-tooltip>

        <my-tooltip :tooltip="$t('_components.btns.BatchUploadEquipment')">
          <a-upload
            name="excel"
            :show-upload-list="false"
            :custom-request="handleUpLoadEquipment"
            :disabled="uploading"
          >
            <div>
              <b-button variant="danger" class="btn ml-0-5 mr-0-5" size="sm">
                <feather-icon icon="UploadIcon" size="18" />
              </b-button>
            </div>
          </a-upload>
        </my-tooltip>
      </template>
      <!-- 扩展功能 -->
      <template slot="menuOther" slot-scope="{ row }">
        <!-- 修改账号 -->
        <div class="btn p-1 ml-0-5" @click="handleEditAccount(row)">
          {{ $t('_components.btns.editAccount') }}
        </div>
        <!-- 修改Team -->
        <div
          v-if="row.isSupervisor !== 1"
          class="btn p-1 ml-0-5"
          @click="handleEditTeam(row)"
        >
          {{ $t('_components.btns.editTeam') }}
        </div>
        <!-- 重置密码 -->
        <div class="btn p-1 ml-0-5" @click="handleResetPassword(row)">
          {{ $t('_components.btns.resetPassword') }}
        </div>
      </template>
    </gtable-crud>

    <c-drawer v-model="drawerVisible" :before-close="handleBeforeClose">
      <component
        :is="formVisibleType"
        v-if="drawerVisible"
        :detail-type="detailType"
        :current-id="currentId"
        :default-form="formVisibleType === 'WorkerFormadd' ? null : searchQuery"
        @closeForm="closeForm"
        @submit="submitCallBack"
      />
    </c-drawer>
    <c-modal
      :header="false"
      :footer="false"
      :visible="dialogShow"
      @close="dialogShow = false"
    >
      <template slot="content">
        <div style="text-align: center;">
          <b-img :src="currentImg" fluid alt="Fluid image')" />
        </div>
      </template>
    </c-modal>
    <c-form
      :visible="accountDrawerShow"
      :data="rowData"
      :option="accountOption"
      @beforeClose="
        () => {
          accountDrawerShow = false
        }
      "
      @submit="handleAccountEdit"
    />

    <c-modal
      title="Reset password"
      :visible="resetPasswordShow"
      @close="resetPasswordShow = false"
      @modelConfirm="handleResetPasswordConfirm"
    >
      <template slot="content">
        {{ $t('_components.message.resetPassword') }}
      </template>
    </c-modal>

    <!-- @close="uploadBlockShow=false" -->
    <c-modal
      :title="i18n('btns.batchUpload')"
      :header="true"
      :footer="false"
      :visible="uploadBlockShow"
      no-back-close="true"
      @close="uploadBlockShow = false"
    >
      <template slot="content">
        <b-overlay
          :show="uploadLoading"
          rounded="sm"
          style="display: inline-block"
        >
          <a-upload-dragger
            name="file"
            :show-upload-list="false"
            :multiple="true"
            :disabled="uploadLoading"
            :custom-request="handleZipUpLoad"
            @change="handleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p class="ant-upload-hint">
              Support for a single or bulk upload. Strictly prohibit from
              uploading company data or otherz band files
            </p>
          </a-upload-dragger>
        </b-overlay>
        <div style="width: 100%;height: 40px;">
          <!-- 文件上传 -->
        </div>
      </template>
    </c-modal>

    <c-modal
      title="Edit team"
      :visible="editTeamSelectionShow"
      @close="editTeamSelectionShow = false"
      @modelConfirm="handleeditTeamConfirm"
    >
      <template slot="content">
        <element-component
          v-model="newTeamCode"
          label="Team"
          :option="{
            type: 'select',
            span: '3',
            dictCode: 'workerteam',
          }"
        />
      </template>
    </c-modal>
  </div>
</template>

<script>
import WORKER, { uploadWorkerFile } from '@/api/worker/index'
import workerOther from '@/api/worker/others'
import {
  getUser,
  update as accountUpdate,
  resetPassword,
} from '@/api/system/user'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BButton,
  BDropdownItem,
  BAvatar,
  BDropdown,
  BBadge,
  BImg,
  BOverlay,
} from 'bootstrap-vue'
import CForm from '@/components/crud/form.vue'
import CModal from '@/components/crud/modal.vue'
import MyTooltip from '@/components/myTooltip.vue'
import CDrawer from '@/components/drawer.vue'
import { deepClone } from '@/util/util'
import ElementComponent from '@/components/elementComponent.vue'
import WorkerFormdetail from './components/detailForm.vue'
import WorkerFormadd from './components/addForm.vue'
import { pageOptions } from '@/config/pageOption'
export default {
  name: 'MyComponent',
  components: {
    BButton,
    MyTooltip,
    CDrawer,
    WorkerFormadd,
    WorkerFormdetail,
    BDropdownItem,
    BAvatar,
    BDropdown,
    BBadge,
    CModal,
    CForm,
    BImg,
    BOverlay,
    ElementComponent,
  },
  props: {
    searchQuery: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 10,
      },
      pageOptions: [],
      currentId: '',
      data: [],
      loading: false,
      dialogShow: false,
      drawerTitle: '',
      drawerVisible: false,
      formVisibleType: '',
      downloading: false,
      uploading: false,
      // 判断detail类型是编辑还是查看
      detailType: 'view',
      currentImg: '',
      // 文件上传弹框
      uploadBlockShow: false,
      uploadLoading: false,
      rowData: {},
      accountDrawerShow: false,
      resetPasswordShow: false,
      editTeamSelectionShow: false,
      newTeamCode: '',
    }
  },
  computed: {
    option() {
      const columnss = [
        {
          label: this.i18n('label.employmentCode'),
          field: 'employmentCode',
          search: true,
          searchBase: true,
          hide: true,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.name'),
          field: 'name',
          search: true,
          searchBase: true,
          formOption: {
            rules: 'required',
          },
        },

        {
          label: this.i18n('label.employmentStatus'),
          field: 'employmentStatus',
          search: true,
          searchBase: true,
          hide: true,
          type: 'select',
          dictData: [
            {
              label: '工人',
              value: '1',
            },
            {
              label: '员工',
              value: '2',
            },
          ],
        },
        {
          label: this.i18n('label.sex'),
          field: 'sex',
          search: false,
          dictField: 'sexName',
          type: 'radio',
          searchSpan: 2,
          dictCode: 'sex',
          formOption: {
            rules: 'required',
          },
        },

        {
          label: this.i18n('label.birthday'),
          field: 'birthday',
          type: 'dateTime',
          dateInputFormat: 'yyyy-MM-dd hh:mm:ss',
          dateOutputFormat: 'MMM do yy',
          hide: true,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.projectId'),
          field: 'projectId',
          type: 'select',
          // dictField: 'projectName',
          dictCode: 'project',
          search: true,
        },
        {
          label: this.i18n('label.team'),
          field: 'teamCode',
          type: 'select',
          dictField: 'teamName',
          dictCode: 'teams',
          search: true,
        },
        {
          label: this.i18n('labelEmployment.specialistId'),
          field: 'specialistId',
          type: 'select',
          dictCode: 'specialist',
          // dictField: 'specialistName',
        },
        {
          label: 'Fin No',
          field: 'finNo',
          search: true,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.nric'),
          field: 'nric',
          hide: true,
          searchBase: true,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.mobile'),
          field: 'mobile',
          hide: true,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.email'),
          field: 'email',
          hide: true,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.specialistId'),
          field: 'specialistId',
          hide: true,
          search: true,
          type: 'select',
          dictField: 'specialistName',
          dictBizCode: 'special',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.$t('system.user.roleId'),
          field: 'roleId',
          type: 'select',
          dictName: 'roleName',
          dictCode: 'baseRole',
          search: true,
          formOption: {
            type: 'check',
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.status'),
          field: 'status',
          type: 'select',
          search: true,
          searchBase: true,
          dictBizCode: 'info_status',
          dictField: 'statusName',
          formOption: {
            rules: 'required',
            type: 'select',
          },
        },
        {
          label: this.i18n('label.isSupervisor'),
          field: 'isSupervisor',
          // type: 'select',
          // dictBizCode: 'worker_supervisor',
          // dictField: 'isSupervisorName',
        },
        {
          label: this.i18n('label.signature'),
          field: 'signature',
        },
        {
          label: this.i18n('labelEmployment.wpNumber'),
          field: 'wpNumber',
          sortable: false,
          width: '300px',
          hide: true,
          search: true,
        },
        {
          label: this.i18n('labelEmployment.wpExpiryDate'),
          field: 'wpExpiryDate',
          type: 'dateRange',
          hide: true,
          search: true,
          formOption: {
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'MMM do yy',
          },
        },
        {
          label: this.i18n('label.passportNumber'),
          field: 'passportNumber',
          hide: true,
          search: true,
        },
        {
          label: this.i18n('label.passportExpiryDate'),
          field: 'passportExpiryDate',
          type: 'dateRange',
          hide: true,
          search: true,
          formOption: {
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'MMM do yy',
          },
        },
        {
          label: this.i18n('label.sortOrder'),
          field: 'createTimeSort',
          hide: true,
          search: true,
          searchSpan: 4,
          searchBase: true,
          type: 'select',
          dictBizCode: 'orderByCreateTime',
        },
        {
          label: this.i18n('label.projectIsNull'),
          field: 'projectIsNull',
          hide: true,
          search: true,
          type: 'select',
          dictData: [
            {
              label: 'Yes',
              value: '0',
            },
            {
              label: 'No',
              value: '1',
            },
          ],
          formOption: {
            type: 'select',
            dictData: [
              {
                label: 'Yes',
                value: '0',
              },
              {
                label: 'No',
                value: '1',
              },
            ],
          },
        },
        {
          label: this.i18n('label.teamIsNull'),
          field: 'teamIsNull',
          hide: true,
          search: true,
          type: 'select',
          dictData: [
            {
              label: 'Yes',
              value: '0',
            },
            {
              label: 'No',
              value: '1',
            },
          ],
          formOption: {
            type: 'radio',
            dictData: [
              {
                label: 'Yes',
                value: '0',
              },
              {
                label: 'No',
                value: '1',
              },
            ],
          },
        },
      ]
      const columns = []

      columnss.forEach((item) => {
        const params = item
        const searchObj = this.searchQuery
          ? this.searchQuery[item.field]
          : undefined
        if (searchObj && params.field !== 'status') {
          // params.searchDisabled = true
        }
        columns.push(params)
      })

      const option = {
        header: true,
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: true,
        isEnterSearch: true,
        batchDelBtn: false, // 批量删除按钮(默认 false)
        uploadBtn: false,
        downloadBtn: false,
        refreshBtn: true,
        search: true,
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form
        searchVisible: false, // 搜索默认展开
        fixedHeader: true, // 固定表头
        lineNumbers: false, // 显示每行数据的下标
        selection: true, // 复选框
        searchSpan: 4,

        columns,
      }
      return option
    },
    statusOption() {
      // 0未读 2已读 4已拒绝 6已邀请
      const option = {
        0: {
          color: 'bg-gradient-secondary',
          visible: true,
        },
        2: {
          color: 'bg-gradient-primary',
          visible: true,
        },
        4: {
          color: 'bg-gradient-danger',
          visible: false,
        },
        6: {
          color: 'bg-gradient-success',
          visible: false,
        },
      }
      return option
    },
    accountOption() {
      const option = {
        columns: [
          {
            label: this.$t('system.user.name'),
            field: 'name',
            formOption: {
              rules: 'required',
            },
          },
          {
            label: this.$t('system.user.realName'),
            field: 'realName',
            searchBase: true,
            formOption: {
              type: 'text',
              rules: 'required',
            },
          },
          {
            label: this.$t('system.user.roleId'),
            field: 'roleId',
            formOption: {
              type: 'check',
              dictCode: 'baseRole',
              rules: 'required',
            },
          },
          {
            label: this.$t('system.user.phone'),
            field: 'phone',
          },
          {
            label: this.$t('system.user.email'),
            field: 'email',
            formOption: {
              type: 'email',
              rules: 'email',
            },
          },
        ],
      }
      return option
    },
  },
  mounted() {
    if (!this.searchQuery) {
      this.searchQuery = {
        status: '1',
        createTimeSort: 'DESC',
        employmentStatus: null,
      }
    }

    this.pageOptions = pageOptions
    this.onLoad(this.page)
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true
      const res = await WORKER.getList(page.currentPage, page.pageSize, {
        ...params,
        ...this.query,
        ...this.searchQuery,
      })
      const { data } = res.data
      this.page.total = data.total
      this.data = data.records
      this.loading = false
    },
    getRowStyle(row) {
      if ((!row.projectId || row.projectId === -1) && row.status === 1) {
        return 'red'
      }
      if (!row.teamName && row.status === 1) {
        return 'yellow'
      }
      return ''
      // return row.projectId? 'row': 'red'
    },
    getStatusOption(status) {
      return this.statusOption[status] || {}
    },
    submitCallBack() {
      this.drawerVisible = false
      this.onLoad(this.page)
    },
    setSupervisor(row) {
      this.$bvModal
        .msgBoxConfirm(this.i18n('message.setSupervisor'), {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Continue',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            WORKER.setSupervis({
              supervisorId: row.workerId,
              projectId: row.projectId,
            }).then((res) => {
              this.onLoad(this.page)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: this.$t('_default.toast.text.success'),
                  variant: 'success',
                },
              })
            })
          }
        })
    },
    cancelSupervis(row) {
      this.$bvModal
        .msgBoxConfirm(this.i18n('message.isCancelSupervisor'), {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Continue',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            WORKER.cancelSupervis({ supervisorId: row.workerId }).then(
              (res) => {
                this.onLoad(this.page)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
              }
            )
          }
        })
    },
    // 搜索按钮被点击
    async searchChange(done, form) {
      console.log(form, 'ssssssssss')
      this.searchQuery = form
      const temp = deepClone(form)
      const cols = this.option.columns

      Object.keys(temp).forEach((key) => {
        const item = temp[key]
        const col = cols.find((o) => o.field === key) || {}
        const colTypeIsRange = col.type === 'dateRange'
        if (colTypeIsRange) {
          const keyStart = key.replace(/Date/, 'DateStart')
          const keyEnd = key.replace(/Date/, 'DateEnd')
          if (Array.isArray(item)) {
            const [start, end] = item
            temp[keyStart] = start
            temp[keyEnd] = end
            delete temp[key]
          }
        }
      })
      this.page.currentPage = 1
      this.query = temp
      await this.onLoad(this.page, temp)
      done()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.searchQuery = {
        status: '1',
        createTimeSort: 'DESC',
      }

      this.page.currentPage = 1
      this.onLoad(this.page)
    },
    getBlobObj(context, fileName) {
      const blob = new Blob([context])
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
    },
    // 点击下载按钮
    handleDownload(e) {
      WORKER.downLoadExcel(Object.assign(this.query, { projectIds : this.searchQuery.projectId })).then((res) => {
        this.getBlobObj(res.data, 'WORKER.xlsx')
      })
    },
    // 点击上传按钮
    handleUpLoad(params) {
      this.uploading = true
      WORKER.uploadWorker('file', params.file)
        .then((res) => {
          this.uploading = false
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
        .catch((err) => {
          this.uploading = false
        })
    },
    handleUpLoadEquipment(params) {
      console.log(params)
      this.uploading = true
      workerOther
        .workerEquipmentImport('file', params.file)
        .then((res) => {
          this.uploading = false
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
        .catch((err) => {
          this.uploading = false
        })
    },

    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    // 批量删除
    batchDelete(e) {
      const ids = e.map((o) => o.id).join()
      WORKER.remove(ids)
        .then(() => {
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.danger'),
              variant: 'danger',
            },
          })
        })
      // 返回复选框选中数据
    },
    rowDel(e) {
      WORKER.remove(e.id)
        .then(() => {
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.danger'),
              variant: 'danger',
            },
          })
        })
      // 返回当前行数据
    },
    // 分页更改
    onPageChange(e) {},
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    getSelectedRows() {
      // 获取复选框勾选数据
      const rows = this.$refs['gtable-crud'].getSelectedRows()
    },
    // 显示文件上传弹窗
    handleBlockShow() {
      this.uploadBlockShow = true
    },
    // 文件上传平台文件上传
    handleZipUpLoad(params) {
      this.uploadLoading = true
      uploadWorkerFile('zipFile', params.file).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.uploadLoading = false
      })
    },
    handleChange(info) {
      const { status } = info.file
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    handleFormOpen(key, row, type) {
      if (row && row.id) {
        this.currentId = row.id
      }
      // this.currentId = row.id

      this.drawerVisible = true
      this.detailType = type
      this.drawerTitle = this.$t(`_components.btns.${key}`)
      this.formVisibleType = `WorkerForm${key}`
    },
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    handleBeforeClose(done) {
      done()
    },
    closeForm() {
      this.drawerVisible = false
    },
    handleImgClick(e) {
      if (e) {
        this.currentImg = e
        this.dialogShow = true
      }
    },
    // 修改账号
    handleEditAccount(row) {
      this.rowData = row
      getUser(row.userId).then((res) => {
        this.rowData = res.data.data
        this.accountDrawerShow = true
      })
    },
    handleEditTeam(row) {
      this.rowData = row
      this.editTeamSelectionShow = true
    },
    handleeditTeamConfirm() {
      WORKER.updateWorkerTeam({
        workerId: this.rowData.id,
        newTeamCode: this.newTeamCode,
      }).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.editTeamSelectionShow = false
        this.onLoad(this.page, this.query)
      })
    },
    handleAccountEdit(done, form) {
      accountUpdate(form).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.accountDrawerShow = false
        this.onLoad(this.page)
        done()
      })
    },
    // 重置密码
    handleResetPassword(row) {
      getUser(row.userId).then((res) => {
        this.rowData = res.data.data
        this.resetPasswordShow = true
      })
    },
    handleResetPasswordConfirm() {
      resetPassword(this.rowData.id).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.resetPasswordShow = false
        this.onLoad(this.page)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.name-cols {
  display: flex;
  align-items: center;
  p {
    margin-bottom: 2px;
    padding: 0;
  }
}
.audit-container {
  text-align: center;
}
.custom-btn {
  &__btn {
    padding-left: 1rem;
    white-space: nowrap;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    &:hover {
      background: #eee;
    }
    &:last-child {
      border: none;
    }
  }
}
</style>

<style lang="scss">
.worker-table .table-content .vgt-responsive {
  height: 700px;
  overflow-y: scroll;
  .clickable.red {
    background: red;
  }
  .clickable.yellow {
    background: yellow;
  }
}
</style>
